import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { fetchLocationHierarchy } from 'queries/locationHierarchy/locationHierarchy'
import { LocationHierarchyFetchProps } from 'types/api'
import { ILocationHierarchyResponse } from 'utils/api'
import { TIME } from 'utils/misc'
import { useAnalytics } from 'utils/analytics'

export function useLocationHierarchy({
    env,
    accessToken,
    location,
    enabled,
}: LocationHierarchyFetchProps): ILocationHierarchyResponse {
    const { trackEvent } = useAnalytics()
    const { oneHour } = TIME
    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.LOCATION_HIERARCHY, location, enabled],
        () =>
            fetchLocationHierarchy({
                env,
                accessToken,
                location,
                trackEvent,
            }),
        {
            enabled,
            staleTime: oneHour,
            cacheTime: oneHour,
            retry: false,
        },
    )

    return { data, isLoading, isError, refetch, remove, error }
}
